import printJS from 'print-js';

/**
 * Метод для печати PDF, хранящегося в виде Blob
 *
 * @param pdfBlob Blob-объект, представляющий PDF
 */
export function printPdf(pdfBlob: Blob): void {
  printJS(URL.createObjectURL(pdfBlob));
}

/**
 * Метод для печати изображений, хранящихся в виде Blob
 *
 * @param imageBlob Blob-объект, представляющий изображение
 */
export function printImage(imageBlob: Blob): void {
  printJS(URL.createObjectURL(imageBlob), 'image');
}
